// extracted by mini-css-extract-plugin
export default {"cardContent":"Board_cardContent__hfnYt"};